<script lang="ts">
    import { Button, TextField } from "attractions";
    import Fa from "svelte-fa";
    import {
        faPlusCircle,
        faMinusCircle,
    } from "@fortawesome/free-solid-svg-icons";
    import type { Puzzle } from "../types";
    import type { Writable } from "svelte/store";

    export let puzzle: Writable<Puzzle>;

    const onAddFeature = () => {
        $puzzle.featNames = [...$puzzle.featNames, ""];
        $puzzle.feats = [
            ...$puzzle.feats,
            new Array($puzzle.feats[0].length).fill(""),
        ];
    };

    const onRemoveFeature = (i: number) => {
        $puzzle.featNames = [
            ...$puzzle.featNames.slice(0, i),
            ...$puzzle.featNames.slice(i + 1),
        ];
        $puzzle.feats = [
            ...$puzzle.feats.slice(0, i),
            ...$puzzle.feats.slice(i + 1),
        ];
    };
</script>

<div class="root-container">
    {#each $puzzle.featNames as featName, i}
        <div class="row-container">
            <div class="feature-name-container">
                <Button
                    noRipple
                    danger
                    disabled={$puzzle.featNames.length <= 2}
                    on:click={() => onRemoveFeature(i)}
                    class="remove-btn"
                >
                    <Fa icon={faMinusCircle} />
                </Button>
                <TextField
                    placeholder="Feature"
                    class="feat-name-field"
                    bind:value={featName}
                />
            </div>
            <div class="feat-container">
                {#each $puzzle.feats[i] as feat}
                    <TextField
                        outline
                        bind:value={feat}
                        placeholder="Value"
                        class="feat-field"
                    />
                {/each}
            </div>
        </div>
    {/each}
    <Button on:click={onAddFeature}>
        <Fa icon={faPlusCircle} />
        <span class="margin-left-sm">Add Feature</span>
    </Button>
</div>

<style lang="scss">
    @use "common.scss";
    @use "sass:color";
    @import "theme.scss";

    :global(.feat-field) {
        width: 84px;
    }

    :global(.feat-field input) {
        border-color: $dark !important;

        &:focus {
            border-color: $primary !important;
        }
    }

    :global(.feat-name-field) {
        width: 96px;
    }

    :global(.feat-name-field input) {
        margin: 0px;
        background: rgba(0, 0, 0, 0) !important;
        border-color: $dark !important;

        &:focus {
            border-color: $primary !important;
        }
    }

    .feature-name-container {
        display: flex;
    }

    .root-container {
        width: 440px;
        min-height: 200px;
        padding: 1.25rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-height: 300px;
        overflow: auto;
    }

    .row-container {
        display: flex;
        gap: 1rem;
        align-items: center;
        width: 100%;
    }

    .feat-container {
        display: flex;
        flex-direction: row;
        justify-items: center;
        align-items: center;
        gap: 0.25rem;
    }
</style>
